import React, { useMemo, useState } from "react";

import { StatusControlWrapper } from "./style";
import { Box, Button, Typography } from "@mui/material";
import { StyleCircle } from "../../../Components/Inputs/Settings/styles";
import {
	INVITATION_PRICING_PLANS_ENUM,
	INVITATION_STATUS,
	INVITATION_STATUSES
} from "../../../store/services/invitations/dto/invitations.dto";
import { useAppDispatch, useAppSelector } from "../../../store";
import { getFullInvitationsState, setOpenPricingModal } from "../../../store/slices/invitations/invitations.slice";
import { InvitationStatusColor } from "../../../constants";
// import { formatCurrency } from "../../../utils/formatCurrency";
// import { getInvitationPrice, getStartPrice } from "../../../utils/getInvitationPrice";
import { useRequestPublishInvitationMutation } from "../../../store/services/invitations/invitations.service";
import { trackEvent } from "../../../utils/analytics";
import { notifyError } from "../../../utils/NotifyError";
import { IError } from "../../../utils/getErrorMessage";
import ConfirmModal from "../../../Components/Modals/ConfirmModal";
import { useParams } from "react-router-dom";
import { Tooltip } from "react-tooltip";
import { trackMetaEvent } from "../../../utils/metaPixel";
import { trackTikTokEvent } from "../../../utils/tiktokPixel";

const MIN_PROGRESS = 40;

const StatusControl = ({ disabledPublish }: { disabledPublish: boolean }) => {
	const params = useParams();

	const invitationId = params.id;
	const [requestPublish, setRequestPublish] = useState(false);
	const { managedInvitation, invitationPayedData } = useAppSelector(getFullInvitationsState);
	const dispatch = useAppDispatch();
	const [callRequestPublishInvitation, { isLoading: isRequestPublishInvitation }] =
		useRequestPublishInvitationMutation();

	const handleRequestPublishInvitation = () => {
		// if (!invitationPayedData.isPayed && invitationPayedData.type < INVITATION_PRICING_PLANS_ENUM.SIGNATURE) {
		// return dispatch(setOpenPricingModal(true));
		// }
		setRequestPublish(true);
	};

	const updateFieldsList = useMemo(() => {
		if (!managedInvitation) return [];
		const { fieldUpdate } = managedInvitation;
		if (!fieldUpdate) return [];
		let list = [];
		if (!fieldUpdate.groom_name) {
			list.push("groom name");
		}
		if (!fieldUpdate.bride_name) {
			list.push("bride name");
		}
		if (!fieldUpdate.wedding_date) {
			list.push("Wedding date");
		}
		if (!fieldUpdate.wedding_coordinates && !fieldUpdate.wedding_location_text) {
			list.push("wedding location");
		}
		return list;
	}, [managedInvitation]);

	const handleRequestPublish = (cancel?: boolean) => {
		if (cancel) {
			// unpublish
			trackEvent("un_publish_invitation", {
				scope: "Invitations",
				description: "Un Publish Invitation"
			});
			trackMetaEvent(
				"un_publish_invitation",
				{ invitation_id: invitationId, currency: managedInvitation?.currency, value: 0 },
				true
			);
			trackTikTokEvent("un_publish_invitation", {
				invitation_id: invitationId
			});
		} else {
			trackEvent("publish_invitation", {
				scope: "Invitations",
				description: "Publish Invitation"
			});
			trackMetaEvent(
				"publish_invitation",
				{ invitation_id: invitationId, currency: managedInvitation?.currency, value: 0 },
				true
			);
			trackTikTokEvent("publish_invitation", {
				invitation_id: invitationId
			});
		}
		callRequestPublishInvitation({ _id: invitationId!, cancel }).then(({ data, error }) => {
			if (data) {
				console.log(data);
				setRequestPublish(false);
			}
			if (error) {
				notifyError(error as IError);
			}
		});
	};

	return (
		<StatusControlWrapper>
			<Box className={"setting_content"}>
				<Typography className={"setting_label"}>Status</Typography>
				<Box className={"setting_value"}>
					<Box display={"flex"} alignItems={"center"} gap={1}>
						<StyleCircle $color={InvitationStatusColor[managedInvitation?.status || 1]} />
						<Typography>{INVITATION_STATUSES[managedInvitation?.status || 1]}</Typography>
					</Box>
				</Box>
			</Box>
			<Box
				className={"action guide_publish_btn"}
				data-tooltip-id={disabledPublish && updateFieldsList.length !== 0 ? "publish_btn_tooltip" : ""}
				data-tooltip-content={`Update ${updateFieldsList
					.map((field, index) => {
						if (index === updateFieldsList.length - 1 && updateFieldsList.length > 1) {
							return ` & ${field}`;
						} else if (index === 0) {
							return field;
						} else {
							return `, ${field}`;
						}
					})
					.join("")} to enable publish`}
				data-tooltip-place="bottom-end"
			>
				{(managedInvitation?.status === INVITATION_STATUS.DRAFT ||
					managedInvitation?.status === INVITATION_STATUS.PENDING ||
					managedInvitation?.status === INVITATION_STATUS.PUBLISHED ||
					managedInvitation?.status === INVITATION_STATUS.ACTION_REQUIRED) && (
					<Button
						variant={"contained"}
						size={"small"}
						disabled={isRequestPublishInvitation || disabledPublish}
						onClick={handleRequestPublishInvitation}
					>
						{managedInvitation?.status === INVITATION_STATUS.DRAFT ||
						managedInvitation?.status === INVITATION_STATUS.ACTION_REQUIRED
							? "Publish"
							: "Un Publish"}
					</Button>
				)}
			</Box>
			{requestPublish && (
				<ConfirmModal
					open={true}
					title={`${managedInvitation?.status === INVITATION_STATUS.DRAFT || managedInvitation?.status === INVITATION_STATUS.ACTION_REQUIRED ? "Publish" : "Un Publish"} Invitation`}
					message={`Are you sure you want to ${managedInvitation?.status === INVITATION_STATUS.DRAFT || managedInvitation?.status === INVITATION_STATUS.ACTION_REQUIRED ? "Publish" : "Un Publish"} this invitation?`}
					onConfirm={() => {
						const shouldCancel =
							managedInvitation?.status !== INVITATION_STATUS.DRAFT &&
							managedInvitation?.status !== INVITATION_STATUS.ACTION_REQUIRED;
						handleRequestPublish(shouldCancel);
					}}
					onClose={() => setRequestPublish(false)}
					confirmText={`Yes, ${managedInvitation?.status === INVITATION_STATUS.DRAFT || managedInvitation?.status === INVITATION_STATUS.ACTION_REQUIRED ? "Publish" : "Un Publish"}`}
					cancelText={"No, Cancel"}
					loading={isRequestPublishInvitation}
				/>
			)}
			<Tooltip id="publish_btn_tooltip" style={{ backgroundColor: "#789DBC", zIndex: 1000, maxWidth: "300px" }} />
		</StatusControlWrapper>
	);
};

export default StatusControl;
